export default class Validator {
    static nationalCode(code) {
        const L = code.length;
        if (L < 8 || parseInt(code, 10) === 0) return false;
        code = ('0000' + code).slice(L + 4 - 10);
        if (parseInt(code.slice(3, 9), 10) === 0) return false;
        const c = parseInt(code.slice(9, 10), 10);
        let s = 0;
        for (let i = 0; i < 9; i++)
            s += parseInt(code.slice(i, i + 1), 10) * (10 - i);
        s = s % 11;
        return (s < 2 && c === s) || (s >= 2 && c === (11 - s));
    }

    static bankCardNumber(card_number) {
        const L = card_number.length;
        if (L < 16 || parseInt(card_number.slice(1, 11), 10) === 0 || parseInt(card_number.slice(10, 16), 10) === 0) return false;
        const c = parseInt(card_number.slice(15, 16), 10);
        let s = 0;
        let k, d;
        for (let i = 0; i < 16; i++) {
            k = (i % 2 === 0) ? 2 : 1;
            d = parseInt(card_number.slice(i, i + 1), 10) * k;
            s += (d > 9) ? d - 9 : d;
        }
        return ((s % 10) === 0);
    }

    static persianDate(date) {
        const pattern = /^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2]\d)|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|31|([1-2]\d)|(0[1-9]))))$/;
        return pattern.test(date);
    }

    static address(address) {
        const pattern = /^([\-\d۱-۹ پچجحخهعغفقثصضشسیبلاتنمکگوئدذرزطظژ])+$/u;
        return pattern.test(address);
    }

    static mobile(mobile) {
        const pattern = /^(\+98|0|98|0098)([ ]|-|[()]){0,2}9\d([ ]|-|[()]){0,2}(?:\d([ ]|-|[()]){0,2}){8}$/;
        return pattern.test(mobile);
    }
}